import Authentication from "@yodlee/common-components/dist/types/interfaces/authentication";
import cookie from "js-cookie";

export const getDatacenterNameFromCookie = (): string | undefined => {
    const raw = cookie.get("datacenterName");
    if (!raw) {
        return undefined;
    }
    try {
        return decodeURIComponent(raw);
    } catch {
        return raw;
    }
};

export const getAuthenticationDetails = (selectedBrand?: any): Authentication => (
    {
        rsession: cookie.get("rsession")!,
        brandId: parseInt(cookie.get("brandId")!),
        brandName: cookie.get("brandName")!,
        applicationId: cookie.get("applicationId")!,
        returnUrl: cookie.get("yccUrl")!,
        selectedBrand: selectedBrand ? selectedBrand : {}
    }
)